import {
  FirestoreDataConverter,
  DocumentSnapshot,
  SnapshotOptions,
  WithFieldValue,
} from "firebase/firestore";
import { Bank } from "../application";

const bankConverter: FirestoreDataConverter<Bank> = {
  toFirestore(bank: WithFieldValue<Bank>) {
    const { id, ...data } = bank;
    return data;
  },
  fromFirestore(snapshot: DocumentSnapshot, options: SnapshotOptions): Bank {
    const data = snapshot.data(options);

    if (!data)
      return {
        id: snapshot.id,
        name: "",
        template: "",
      };

    return {
      id: snapshot.id,
      name: data.name || "",
      template: data.template || "",
    };
  },
};

export { bankConverter };
